import { readCookie } from "./commonUtils";

export const getConsent = (): { userconsent?: string; yleconsent?: string } => {
  const userconsent = readCookie("userconsent");
  const yleconsent = readCookie("yleconsent");

  if (userconsent) {
    // a new consent cookie
    return { userconsent };
  }
  if (yleconsent) {
    // Old version of the consent cookie
    return { yleconsent };
  }

  return {};
};

export const snowplowAnalyticsExists = (): boolean => {
  return !!window.yleSnowplow && !!window.yleSnowplowReady;
};

export const waitForSnowplowAnalyticsReady = async (): Promise<void> => {
  return snowplowAnalyticsExists() ? window.yleSnowplowReady : undefined;
};
